<template>
  <div class="wrapper">
    <div class="venn-popup__download-image" v-if="!isDataLoading">
      <BaseScreenshot id="venn-popup-content" :name="screenshotName"/>
    </div>
    <div class="venn-popup__header">
      <div class="venn-popup__header-title"
           :title="title">{{title}}
      </div>
    </div>
    <div class="venn-popup__content" id="venn-popup-content">
      <base-loader v-if="isDataLoading"/>
      <VennDiagram
        v-else
        :custom-report="overlapCustomReport"
        :config="overlapChartData">
      </VennDiagram>
    </div>
    <div class="venn-popup__controls">
      <button class="venn-popup__button venn-popup__button_submit" @click.prevent="cancel">Close</button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import filters from '@/common/Filters'
import VennDiagram from './VennDiagram'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import { convertAdvancedOptionsToFilters } from '@/features/reports/common/advanced-options/config'
import AttributeReport from "../attribute/AttributeReport";
/**
 * Venn diagram modal
 * Used in {@link AttributeReport}
 */
export default {
  name: 'VennDiagramPopup',
  data () {
    return {
      isDataFetched: false
    }
  },
  components: {
    VennDiagram
  },
  created () {
    this.loadOverlapChartData()
  },
  props: {
    title: {
      type: String,
      required: true
    },
    selectedIds: {
      type: Object,
      required: true
    },
    selectedAdvancedOptions: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  computed: {
    ...mapState({
      selectedClient: 'selectedClient'
    }),
    ...mapState('attributeReport', [
      'overlapChartData',
      'overlapCustomReport'
    ]),
    isDataLoading() {

      return !this.overlapChartData || !this.overlapCustomReport
    },
    screenshotName(){
      return `${this.selectedClient.name}_AttributeReport_${moment(Date.now()).format('YYYY-MM-DD')}`
    }
  },
  methods: {
    ...mapActions('attributeReport', [
      'getOverlapChartData',
      'getCustomReport'
    ]),
    cancel () {
      this.$emit('close')
    },
    async loadOverlapChartData () {
      const { exclude, include } = this.selectedIds
      const clientId = this.clientId
      const ids = exclude.concat(include).filter(item => !_.isEmpty(item))
      this.getOverlapChartData({ clientId, ids })
      const advancedFilters = convertAdvancedOptionsToFilters(this.selectedAdvancedOptions)
      this.getCustomReport({ clientId, filters: { selectedIds: this.selectedIds, advancedFilters } })
    }
  },
  filters: {
    ...filters
  }
}
</script>

<style scoped lang="scss">

  .wrapper {
    padding: 40px;
    background-color: #fff;
    border-radius: 13px;
    position: relative;
  }

  .venn-popup {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 30px;

    &__download-image {
      position: absolute;
      right: 30px;
      top: 50px;
      z-index: 1000;
      font-size: 16px;
    }

    &__header {
      display: flex;
      justify-content: center;
      width: 100%;
      height: 40px;
      position: relative;
      margin-bottom: 30px;

      &-title {
        text-align: center;
        font-size: 34px;
        font-weight: 500;
        max-width: 840px;
        @include ellipsis;
      }

      &__content {
        text-align: center;
        font-size: 34px;
        font-weight: 500;
        max-width: 840px;
        color: $rfx-dark-march;
        @include ellipsis;
      }
    }

    &__content {
      display: inline-flex;
      padding-left: 10px;
      min-width: 100%;
      align-items: center;
      justify-content: center;
      border-radius: $rfx-default-border-radius $rfx-default-border-radius 0 0;
      min-height: 350px;
    }

    &__controls {
      display: flex;
      justify-content: flex-end;
      margin-top: 30px;
    }

    &__button {
      width: 100px;
      height: 40px;
      border-radius: 4px;
      font-size: 10px;
      font-weight: 900;
      text-transform: uppercase;
      margin-left: 30px;
      border: none;
      outline: none;
      cursor: pointer;

      &_submit {
        background-color: $rfx-medium-march;
        color: #fff;
      }
    }
  }
</style>
